
import { css } from 'lit';
export default css`
:host {
  display: block;
}

p {
  margin-bottom: 1.75rem;
  font-family: Lato, sans-serif;
  font-size: 1.125rem;
  line-height: 1.5;
}

@media (min-width: 1024px) {

  p {
    margin-bottom: 2rem;
  }

  p {
    font-size: 1.25rem;
  }
}

.paragraph--bold {
  font-weight: 700;
}

.paragraph--italic {
  font-style: italic;
}

.paragraph--small {
  font-size: 1rem;
}

@media (min-width: 1024px) {

  .paragraph--small {
    font-size: 1.125rem;
  }
}

.paragraph--location-card {
  margin: 0px;
  margin-bottom: 1rem;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
}

@media (min-width: 1024px) {

  .paragraph--location-card {
    margin-bottom: 0px;
  }

  .paragraph--location-card {
    font-size: 1.25rem;
  }

  .paragraph--location-card {
    line-height: 1.5;
  }
}

.paragraph--location-card-map {
  margin: 0px;
  margin-bottom: 1rem;
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.5;
}

@media (min-width: 1024px) {

  .paragraph--location-card-map {
    margin-bottom: 0px;
  }
}

.paragraph--legal {
  margin: 0px;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.4;
}

@media (min-width: 1024px) {

  .paragraph--legal {
    font-size: 1rem;
  }
}

.paragraph--legal-footer {
  margin: 0px;
  font-size: 0.875rem;
  line-height: 1.4;
}

@media (min-width: 1024px) {

  .paragraph--legal-footer {
    font-size: 1rem;
  }
}

.paragraph--large {
  margin-top: 0px;
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.625;
}

@media (min-width: 1024px) {

  .paragraph--large {
    font-size: 1.25rem;
  }

  .paragraph--large {
    line-height: 1.625;
  }
}

.paragraph--cta-card {
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 1.125rem;
}

.paragraph--image-placemat-cta {
  margin-top: 0px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.625;
}

@media (min-width: 1024px) {

  .paragraph--image-placemat-cta {
    font-size: 1.25rem;
  }

  .paragraph--image-placemat-cta {
    line-height: 1.625;
  }
}

.paragraph--connect-with-us {
  margin-top: 0px;
  margin-bottom: 0px;
}

@media (min-width: 768px) {

  .paragraph--connect-with-us {
    margin-top: 2rem;
  }

  .paragraph--connect-with-us {
    margin-bottom: 1.75rem;
  }
}

@media (min-width: 1024px) {

  .paragraph--connect-with-us {
    margin-top: 0px;
  }
}

.paragraph--no-margin {
  margin: 0px;
}

p.attribution {
  font-family: Lato, sans-serif;
  font-size: 1.25rem;
  font-style: italic;
}

p.attribution::before {
  margin-right: 0.5rem;
}

p.attribution::before {
  display: inline-block;
}

p.attribution::before {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

p.attribution::before {
  vertical-align: middle;
}

p.attribution::before {
    content: '';
    height: 2.5px;
    width: 8px;
  }

@media (min-width: 1024px) {

  p.attribution {
    font-size: 1.375rem;
  }
}

p.cta-featured__text {
  margin-bottom: 0px;
}

.paragraph--accordion-response {
  margin: 0px;
}

.paragraph--accordion-prompt {
  font-size: 22px;
  margin: 0px;
}

.paragraph--cta-image {
  margin: 0px;
  margin-bottom: -1rem;
}

.paragraph--mlp-hero {
  margin-bottom: 0;
}

.bg-purple a {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.bg-purple a:hover {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.paragraph--people-grid {
  font-size: 1.125rem;
  line-height: 1.575rem;
  font-style: italic;
  font-weight: 400;
  margin: 0;
}
`;